import { render } from "./installation-persons.vue?vue&type=template&id=df8f2d78"
import script from "./installation-persons.vue?vue&type=script&lang=js"
export * from "./installation-persons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__